/**
 * BudgetChangeRequestTypeService
 * Service for BudgetChangeRequestType lookup CRUD operations
 * (1 IncreaseAmount).
 */
import { CrudService } from '../base/CrudService';
/** Service for BudgetChangeRequestType CRUD operations */
export class BudgetChangeRequestTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? BudgetChangeRequestTypeService.DEFAULT_SERVICE_PATH,
            basePath: BudgetChangeRequestTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
BudgetChangeRequestTypeService.DEFAULT_SERVICE_PATH = 'budgets';
BudgetChangeRequestTypeService.BASE_PATH = 'api/budget-change-request-types';
//# sourceMappingURL=BudgetChangeRequestTypeService.js.map